/**
 * Native mobile integrations for Capacitor-wrapped Android app.
 * Safe to import on web too — all native calls are no-ops if not in a Capacitor env.
 */
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";

export const isNative = () => Capacitor.isNativePlatform();

/**
 * Initialize native behaviors:
 * - Style status bar to match app theme (dark content on saffron header bg)
 * - Handle Android hardware back-button → history.back() or minimize if at root
 * - Hide splash screen after boot
 */
export async function initNativeApp() {
  if (!isNative()) return;

  try {
    // Status bar: show, dark style (light content on dark bg)
    await StatusBar.setBackgroundColor({ color: "#1c1917" });
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (e) {
    console.warn("[Native] StatusBar setup failed:", e);
  }

  // Android hardware back button behavior
  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack && window.history.length > 1) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  // Confirm on exit when on Home page (optional — simple UX)
  App.addListener("appStateChange", ({ isActive }) => {
    // Can persist/restore state here if needed
    void isActive;
  });

  // Hide the splash after the React tree has mounted + a short delay
  setTimeout(async () => {
    try {
      await SplashScreen.hide({ fadeOutDuration: 300 });
    } catch (e) {
      console.warn("[Native] SplashScreen.hide failed:", e);
    }
  }, 800);
}
